import { S1, S2, S3, S4 } from "./SlidesA";
import { S5, S6, S7, S8 } from "./SlidesB";
import { S9, S10, S11, S12 } from "./SlidesC";

const DIM = { lat: 25, lon: 30, dist: 9.5, x: 0, opacity: 0.16, spin: true };

const COVER = {
  lat: 26, lon: 22, dist: 6.4, x: 1.75, y: -0.15, spin: true,
  arcs: [
    { from: "algeria", to: "italia" },
    { from: "azerbaigian", to: "italia", color: "#ff8a3a" },
    { from: "qatar", to: "italia", color: "#6cc5ff" },
    { from: "russia", to: "italia", color: "#ff5a1f" },
    { from: "usa", to: "italia", color: "#6cc5ff", lift: 0.45 },
  ],
};

export const SLIDES = [
  { C: S1, kicker: "Copertina", title: "ENI e la sostituzione del gas russo", globe: COVER },
  { C: S2, kicker: "2021", title: "Il pilastro russo", globe: { lat: 45, lon: 40, dist: 8, x: 0.4, opacity: 0.3, arcs: [{ from: "russia", to: "italia", color: "#ff5a1f", radius: 0.02 }] } },
  { C: S3, kicker: "2021–2024", title: "Il crollo", globe: DIM },
  { C: S4, kicker: "Africa e Mediterraneo", title: "ENI non partiva da zero", globe: { lat: 8, lon: 20, dist: 5.6, x: 1.25, markers: ["algeria", "libia", "egitto", "congo", "mozambico"] } },
  { C: S5, kicker: "Gasdotto", title: "Algeria e TransMed", globe: { lat: 37, lon: 9, dist: 4.8, x: 0.6, y: -0.05, markers: ["algeria", "italia"], arcs: [{ wps: "transmed", radius: 0.007, pulses: 6, speed: 0.22 }] } },
  { C: S6, kicker: "Importazioni 2024", title: "Non sostituzione, ma moltiplicazione", globe: DIM },
  { C: S7, kicker: "GNL", title: "Il GNL rende il gas flessibile", globe: { lat: 30, lon: -5, dist: 6.3, x: 1.3, markers: ["qatar", "algeria", "usa", "italia"], markerColor: "#6cc5ff", ships: ["qatar", "algeriaLng", "usa"] } },
  { C: S8, kicker: "Upstream", title: "Tre progetti, tre geografie", globe: DIM },
  { C: S9, kicker: "Rigassificazione", title: "Piombino e Ravenna", globe: DIM },
  { C: S10, kicker: "Confronto", title: "Prima e dopo: 2021 contro 2024", globe: DIM },
  { C: S11, kicker: "Strategia", title: "Finanza, strategia e conclusione", globe: DIM },
  { C: S12, kicker: "Fonti", title: "Bibliografia", globe: DIM },
];
